export default "__VITE_ASSET__VZxnneXQ__"